export const COUNTRY_CANADA = "Canada"
export const COUNTRY_UNITED_STATES = "United States"
export const COUNTRY_JAPAN = "Japan"

export const COUNTRIES_CANADA_US = [COUNTRY_CANADA, COUNTRY_UNITED_STATES]

